
import { useState, useEffect, memo, useCallback, useMemo } from "react";
import { CSVLink } from "react-csv";
import { useNavigate } from "react-router-dom";
import AnimacionCarga from "./animacion_de_carga";
import TablaGenerica from "./tablas";
import BarraSuperior from "./barra_superior";
import BotonSOS from "./sos/boton_sos";
import { obtenerTickets } from "../../functions/consultas";
import { subirArchivoFirebase } from "../../functions/archivos_firebase";
import { crearRegistro, actualizarRegistro, eliminarRegistro, consultarSimple, actualizarMultiple } from "../../functions/crud";
import {
  CORREO_SOPORTE, RUTA_LISTADO, ESTADOS, RESPONSABLES, CARGOS,
  CAMPOS_FOTO, CAMPOS_SOLUCION, MAX_FOTOS,
  normalizarEstado, normalizarNombre, soloFecha, fechaLegible,
  fotosDe, repartirFotos, paletaEstado,
  cargarCategorias, cargarUsuariosTickets,
  Modal, Campo, BadgeEstado, GaleriaFotos, VisorFoto, PanelFirma,
  useConfirmacion, useAviso, enviarCorreoTicket,
} from "./tickets/comunes";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../css/tickets.css";

const TODOS = "__todos__";

const COLUMNAS = [
  { label: "Contador", key: "contador" },
  { label: "Fecha", key: "fecha_del_reporte" },
  { label: "Cargo", key: "cargo_funcionario" },
  { label: "Nombre completo", key: "nombre_funcionario" },
  { label: "Categoría", key: "categoria" },
  { label: "Descripción del problema", key: "descripcion_problema" },
  { label: "Estado", key: "estado_del_ticket" },
];

const COLUMNAS_CSV = [
  ...COLUMNAS,
  { label: "Responsable", key: "responsable_del_ticket" },
  { label: "Correo solicitante", key: "correo_solicitante" },
  { label: "Proceso", key: "proceso_del_funcionario" },
  { label: "Solución", key: "descripcion_solucion" },
  { label: "Fecha de cierre", key: "fecha_fin_solucion" },
  { label: "Foto 1", key: "url_foto_1" },
];

const ahora = () => {
  const iso = new Date().toISOString();
  return { fecha: iso.substring(0, 10), hora: iso.substring(11, 16), completo: iso };
};


const ModalCrear = ({ categorias, usuarios, correoActual, alGuardar, alCerrar }) => {
  const [datos, setDatos] = useState({
    categoria: "", cargo: "", nombre: "", proceso: "",
    correo: correoActual, descripcion: "",
  });
  const [archivos, setArchivos] = useState([]);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  const cambiar = (campo) => (e) => setDatos((d) => ({ ...d, [campo]: e.target.value }));

  const elegirUsuario = (e) => {
    const usuario = usuarios.find((u) => u.id === e.target.value);
    if (!usuario) return;
    setDatos((d) => ({
      ...d,
      nombre: usuario.Nombre_Completo || "",
      cargo: usuario.Cargo || d.cargo,
      proceso: usuario.Proceso || "",
      correo: usuario.Usuario || d.correo,
    }));
  };

  const enviar = async () => {
    if (!datos.categoria) return setError("Selecciona una categoría.");
    if (!datos.cargo.trim()) return setError("El cargo es obligatorio.");
    if (!datos.nombre.trim()) return setError("El nombre es obligatorio.");
    if (!datos.descripcion.trim()) return setError("La descripción del problema es obligatoria.");

    setError("");
    setGuardando(true);
    try {
      await alGuardar(datos, archivos);
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Modal
      titulo="Nuevo ticket"
      subtitulo="Cuéntanos qué ocurre y adjunta evidencia si la tienes"
      ancho="lg"
      alCerrar={alCerrar}
      pie={
        <>
          {error && <span style={{ color: "#b3261e", fontSize: "0.8rem" }}>{error}</span>}
          <div className="tk-derecha">
            <button type="button" className="tk-btn" onClick={alCerrar} disabled={guardando}>Cancelar</button>
            <button type="button" className="tk-btn tk-btn-primario" onClick={enviar} disabled={guardando}>
              {guardando ? "Creando…" : "Crear ticket"}
            </button>
          </div>
        </>
      }
    >
      <div className="tk-rejilla">
        {usuarios.length > 0 && (
          <Campo
            etiqueta="Usuario registrado"
            ayuda="Opcional: completa los datos del solicitante automáticamente."
            anchoTotal
          >
            <select onChange={elegirUsuario} defaultValue="">
              <option value="">— Escribir manualmente —</option>
              {usuarios.map((u) => (
                <option key={u.id} value={u.id}>{u.Nombre_Completo || u.Usuario}</option>
              ))}
            </select>
          </Campo>
        )}

        <Campo etiqueta="Categoría">
          <select value={datos.categoria} onChange={cambiar("categoria")}>
            <option value="">Selecciona una categoría</option>
            {categorias.map((c) => (
              <option key={c.id} value={c.descripcion_categoria}>{c.descripcion_categoria}</option>
            ))}
          </select>
        </Campo>

        <Campo etiqueta="Cargo del funcionario">
          <input
            type="text"
            list="tk-cargos"
            value={datos.cargo}
            onChange={cambiar("cargo")}
            placeholder="Ej. Ejecutivo de Cuenta"
          />
          <datalist id="tk-cargos">
            {CARGOS.map((c) => <option key={c} value={c} />)}
          </datalist>
        </Campo>

        <Campo etiqueta="Nombre completo">
          <input type="text" value={datos.nombre} onChange={cambiar("nombre")} placeholder="Nombre y apellido" />
        </Campo>

        <Campo etiqueta="Proceso">
          <input type="text" value={datos.proceso} onChange={cambiar("proceso")} placeholder="Área o proceso" />
        </Campo>

        <Campo etiqueta="Correo del solicitante" anchoTotal>
          <input type="text" value={datos.correo} onChange={cambiar("correo")} placeholder="correo@dominio.com" />
        </Campo>

        <Campo etiqueta="Descripción del problema" anchoTotal>
          <textarea
            value={datos.descripcion}
            onChange={cambiar("descripcion")}
            placeholder="Describe con detalle qué está pasando…"
          />
        </Campo>

        <Campo etiqueta={`Fotos del problema (hasta ${MAX_FOTOS})`} anchoTotal>
          <GaleriaFotos archivos={archivos} alCambiarArchivos={setArchivos} />
        </Campo>
      </div>
    </Modal>
  );
};


const ModalDuplicar = ({ ticket, alGuardar, alCerrar }) => {
  const [fecha, setFecha] = useState(soloFecha(ticket.fecha_del_reporte) || "");
  const [descripcion, setDescripcion] = useState(ticket.descripcion_problema || "");
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  const enviar = async () => {
    if (!descripcion.trim()) return setError("La descripción del problema es obligatoria.");
    setError("");
    setGuardando(true);
    try {
      await alGuardar({ fecha, descripcion });
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Modal
      titulo={`Duplicar ticket #${ticket.contador || "—"}`}
      subtitulo="Ajusta la fecha y la descripción antes de crear la copia"
      ancho="md"
      alCerrar={alCerrar}
      pie={
        <>
          {error && <span style={{ color: "#b3261e", fontSize: "0.8rem" }}>{error}</span>}
          <div className="tk-derecha">
            <button type="button" className="tk-btn" onClick={alCerrar} disabled={guardando}>Cancelar</button>
            <button type="button" className="tk-btn tk-btn-primario" onClick={enviar} disabled={guardando}>
              {guardando ? "Duplicando…" : "Duplicar ticket"}
            </button>
          </div>
        </>
      }
    >
      <div className="tk-rejilla">
        <Campo etiqueta="Fecha de creación del ticket">
          <input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} />
        </Campo>

        <Campo etiqueta="Descripción del problema" anchoTotal>
          <textarea
            value={descripcion}
            onChange={(e) => setDescripcion(e.target.value)}
            placeholder="Describe con detalle qué está pasando…"
            style={{ minHeight: 130 }}
          />
        </Campo>
      </div>
    </Modal>
  );
};


const PESTANAS = [
  { id: "solicitante", etiqueta: "Solicitante", icono: "bi-person" },
  { id: "seguimiento", etiqueta: "Seguimiento", icono: "bi-flag" },
  { id: "solucion", etiqueta: "Solución", icono: "bi-check2-circle" },
  { id: "firmas", etiqueta: "Firmas", icono: "bi-pen" },
];

const ModalGestionar = ({ ticket, usuarios, alGuardar, alCerrar, alAmpliar }) => {
  const [pestana, setPestana] = useState("seguimiento");
  const [guardando, setGuardando] = useState(false);
  const [firmando, setFirmando] = useState(null);

  const [datos, setDatos] = useState({
    estado: normalizarEstado(ticket.estado_del_ticket),
    responsable: ticket.responsable_del_ticket || "",
    nombre: ticket.nombre_funcionario || "",
    cargo: ticket.cargo_funcionario || "",
    proceso: ticket.proceso_del_funcionario || "",
    correo: ticket.correo_solicitante || "",
    solucion: ticket.descripcion_solucion || "",
    firmaSolicitante: ticket.url_firma_solicitante || "",
    firmaTecnologia: ticket.url_firma_tecnologia || "",
    fecha: soloFecha(ticket.fecha_del_reporte) || "",
  });

  const [urlsSolucion, setUrlsSolucion] = useState(fotosDe(ticket, CAMPOS_SOLUCION));
  const [archivosSolucion, setArchivosSolucion] = useState([]);

  const cambiar = (campo) => (e) => setDatos((d) => ({ ...d, [campo]: e.target.value }));

  const elegirUsuario = (e) => {
    const usuario = usuarios.find((u) => u.id === e.target.value);
    if (!usuario) return;
    setDatos((d) => ({
      ...d,
      nombre: usuario.Nombre_Completo || "",
      cargo: usuario.Cargo || "",
      proceso: usuario.Proceso || "",
      correo: usuario.Usuario || "",
    }));
  };

  const enviar = async () => {
    setGuardando(true);
    try {
      await alGuardar(datos, { urlsSolucion, archivosSolucion });
    } finally {
      setGuardando(false);
    }
  };

  const fotosProblema = fotosDe(ticket, CAMPOS_FOTO);

  return (
    <>
      <Modal
        titulo={`Ticket #${ticket.contador || "—"}`}
        subtitulo={`${ticket.categoria || "Sin categoría"} · reportado el ${fechaLegible(ticket.fecha_del_reporte)}`}
        ancho="lg"
        alCerrar={alCerrar}
        pie={
          <>
            <BadgeEstado estado={datos.estado} />
            <div className="tk-derecha">
              <button type="button" className="tk-btn" onClick={alCerrar} disabled={guardando}>Cancelar</button>
              <button type="button" className="tk-btn tk-btn-primario" onClick={enviar} disabled={guardando}>
                {guardando ? "Guardando…" : "Guardar cambios"}
              </button>
            </div>
          </>
        }
      >
        <div className="tk-segmentado">
          {PESTANAS.map((p) => (
            <button
              key={p.id}
              type="button"
              className={pestana === p.id ? "activo" : ""}
              onClick={() => setPestana(p.id)}
            >
              <i className={`bi ${p.icono}`} /> {p.etiqueta}
            </button>
          ))}
        </div>

        {pestana === "solicitante" && (
          <div className="tk-rejilla">
            <Campo
              etiqueta="Asignar usuario registrado"
              ayuda="Al elegir uno se completan los campos de abajo; también puedes escribirlos."
              anchoTotal
            >
              <select onChange={elegirUsuario} defaultValue="">
                <option value="">— Elegir de la lista —</option>
                {usuarios.map((u) => (
                  <option key={u.id} value={u.id}>{u.Nombre_Completo || u.Usuario}</option>
                ))}
              </select>
            </Campo>

            <Campo etiqueta="Nombre del solicitante">
              <input type="text" value={datos.nombre} onChange={cambiar("nombre")} />
            </Campo>
            <Campo etiqueta="Cargo">
              <input type="text" value={datos.cargo} onChange={cambiar("cargo")} />
            </Campo>
            <Campo etiqueta="Proceso">
              <input type="text" value={datos.proceso} onChange={cambiar("proceso")} />
            </Campo>
            <Campo etiqueta="Correo">
              <input type="text" value={datos.correo} onChange={cambiar("correo")} />
            </Campo>
          </div>
        )}

        {pestana === "seguimiento" && (
          <div className="tk-rejilla">
            <Campo etiqueta="Estado del ticket">
              <select value={datos.estado} onChange={cambiar("estado")}>
                {ESTADOS.map((e) => <option key={e} value={e}>{e}</option>)}
              </select>
            </Campo>

            <Campo etiqueta="Responsable">
              <select value={datos.responsable} onChange={cambiar("responsable")}>
                <option value="">Sin asignar</option>
                {RESPONSABLES.map((r) => <option key={r} value={r}>{r}</option>)}
              </select>
            </Campo>

            <Campo etiqueta="Fecha de creación del ticket">
              <input type="date" value={datos.fecha} onChange={cambiar("fecha")} />
            </Campo>

            <div className="tk-ancho-total tk-bloque">
              <h4>Problema reportado</h4>
              <pre>{ticket.descripcion_problema || "—"}</pre>
            </div>

            <div className="tk-ancho-total">
              <Campo etiqueta="Fotos del problema">
                <GaleriaFotos urls={fotosProblema} soloLectura alAmpliar={alAmpliar} />
              </Campo>
            </div>
          </div>
        )}

        {pestana === "solucion" && (
          <div className="tk-rejilla">
            <Campo
              etiqueta="Observaciones / solución"
              ayuda="Al guardar se agrega tu nombre y la fecha al final del comentario."
              anchoTotal
            >
              <textarea
                value={datos.solucion}
                onChange={cambiar("solucion")}
                placeholder="Describe la solución aplicada…"
                style={{ minHeight: 130 }}
              />
            </Campo>

            <Campo etiqueta={`Fotos de la solución (hasta ${MAX_FOTOS})`} anchoTotal>
              <GaleriaFotos
                urls={urlsSolucion}
                archivos={archivosSolucion}
                alCambiarUrls={setUrlsSolucion}
                alCambiarArchivos={setArchivosSolucion}
                alAmpliar={alAmpliar}
              />
            </Campo>
          </div>
        )}

        {pestana === "firmas" && (
          <div className="tk-rejilla">
            {[
              { clave: "firmaSolicitante", titulo: "Firma del solicitante", tipo: "solicitante" },
              { clave: "firmaTecnologia", titulo: "Firma de tecnología", tipo: "tecnologia" },
            ].map(({ clave, titulo, tipo }) => (
              <div className="tk-firma-caja" key={clave}>
                <strong>{titulo}</strong>
                {datos[clave]
                  ? <img src={datos[clave]} alt={titulo} />
                  : <p className="tk-vacio" style={{ padding: "22px 0" }}>Sin firma registrada</p>}
                <div style={{ display: "flex", gap: 8, marginTop: 12, justifyContent: "center" }}>
                  <button type="button" className="tk-btn" onClick={() => setFirmando({ clave, titulo, tipo })}>
                    <i className="bi bi-pen" /> {datos[clave] ? "Volver a firmar" : "Firmar"}
                  </button>
                  {datos[clave] && (
                    <button
                      type="button"
                      className="tk-btn tk-btn-peligro"
                      onClick={() => setDatos((d) => ({ ...d, [clave]: "" }))}
                    >
                      Quitar
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </Modal>

      {firmando && (
        <PanelFirma
          titulo={firmando.titulo}
          alCerrar={() => setFirmando(null)}
          alGuardar={(dataUrl) => {
            setDatos((d) => ({ ...d, [firmando.clave]: dataUrl }));
            setFirmando(null);
          }}
        />
      )}
    </>
  );
};


const ModalDetalle = ({ ticket, alCerrar, alAmpliar }) => {
  const fotosProblema = fotosDe(ticket, CAMPOS_FOTO);
  const fotosSolucion = fotosDe(ticket, CAMPOS_SOLUCION);

  return (
    <Modal
      titulo={`Ticket #${ticket.contador || "—"}`}
      subtitulo={ticket.categoria || "Sin categoría"}
      ancho="lg"
      alCerrar={alCerrar}
      pie={
        <div className="tk-derecha">
          <button type="button" className="tk-btn tk-btn-primario" onClick={alCerrar}>Cerrar</button>
        </div>
      }
    >
      <div className="tk-rejilla">
        <div className="tk-bloque tk-ancho-total" style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
          <BadgeEstado estado={ticket.estado_del_ticket} />
          <span style={{ fontSize: "0.82rem", color: "var(--tk-gris)" }}>
            Reportado el {fechaLegible(ticket.fecha_del_reporte)}
            {ticket.hora_del_reporte ? ` a las ${ticket.hora_del_reporte}` : ""}
          </span>
          {ticket.fecha_fin_solucion && (
            <span style={{ fontSize: "0.82rem", color: "var(--tk-gris)", marginLeft: "auto" }}>
              Cerrado el {fechaLegible(ticket.fecha_fin_solucion)} {ticket.hora_fin_solucion || ""}
            </span>
          )}
        </div>

        <div className="tk-bloque">
          <h4>Solicitante</h4>
          <dl style={{ margin: 0 }}>
            <div className="tk-dato"><dt>Nombre</dt><dd>{ticket.nombre_funcionario || "—"}</dd></div>
            <div className="tk-dato"><dt>Cargo</dt><dd>{ticket.cargo_funcionario || "—"}</dd></div>
            <div className="tk-dato"><dt>Proceso</dt><dd>{ticket.proceso_del_funcionario || "—"}</dd></div>
            <div className="tk-dato"><dt>Correo</dt><dd>{ticket.correo_solicitante || "—"}</dd></div>
          </dl>
        </div>

        <div className="tk-bloque">
          <h4>Gestión</h4>
          <dl style={{ margin: 0 }}>
            <div className="tk-dato"><dt>Responsable</dt><dd>{ticket.responsable_del_ticket || "Sin asignar"}</dd></div>
            <div className="tk-dato"><dt>Categoría</dt><dd>{ticket.categoria || "—"}</dd></div>
            <div className="tk-dato"><dt>Consecutivo</dt><dd>#{ticket.contador || "—"}</dd></div>
            <div className="tk-dato"><dt>Última actualización</dt><dd>{fechaLegible(ticket.fecha_actualizacion) || "—"}</dd></div>
          </dl>
        </div>

        <div className="tk-bloque tk-ancho-total" style={{ borderLeft: "3px solid #f39c12" }}>
          <h4>Problema</h4>
          <pre>{ticket.descripcion_problema || "—"}</pre>
        </div>

        {fotosProblema.length > 0 && (
          <div className="tk-ancho-total">
            <Campo etiqueta="Fotos del problema">
              <GaleriaFotos urls={fotosProblema} soloLectura alAmpliar={alAmpliar} />
            </Campo>
          </div>
        )}

        {ticket.descripcion_solucion && (
          <div className="tk-bloque tk-ancho-total" style={{ borderLeft: "3px solid #27ae60" }}>
            <h4>Solución</h4>
            <pre>{ticket.descripcion_solucion}</pre>
          </div>
        )}

        {fotosSolucion.length > 0 && (
          <div className="tk-ancho-total">
            <Campo etiqueta="Fotos de la solución">
              <GaleriaFotos urls={fotosSolucion} soloLectura alAmpliar={alAmpliar} />
            </Campo>
          </div>
        )}

        {(ticket.url_firma_solicitante || ticket.url_firma_tecnologia) && (
          <>
            {ticket.url_firma_solicitante && (
              <div className="tk-firma-caja">
                <strong>Firma del solicitante</strong>
                <img src={ticket.url_firma_solicitante} alt="Firma del solicitante" />
              </div>
            )}
            {ticket.url_firma_tecnologia && (
              <div className="tk-firma-caja">
                <strong>Firma de tecnología</strong>
                <img src={ticket.url_firma_tecnologia} alt="Firma de tecnología" />
              </div>
            )}
          </>
        )}
      </div>
    </Modal>
  );
};


const ListadoTickets = memo(() => {
  const navegar = useNavigate();

  const [datos, setDatos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [cargando, setCargando] = useState(true);

  const [filtros, setFiltros] = useState({
    estado: TODOS, responsable: TODOS, categoria: TODOS, desde: "", hasta: "",
  });

  const [modal, setModal] = useState(null);
  const [fotoAmpliada, setFotoAmpliada] = useState(null);

  const { elemento: confirmacion, pedirConfirmacion } = useConfirmacion();
  const { elemento: aviso, avisar } = useAviso();

  const correoActual = localStorage.getItem("CorreoElectronico") || "";
  const esSoporte = correoActual === CORREO_SOPORTE;

  const cerrarModal = useCallback(() => setModal(null), []);


  const capturarDatos = useCallback(async () => {
    try {
      const data = await obtenerTickets();
      const lista = (Array.isArray(data)
        ? data
        : Object.entries(data || {}).map(([id, item]) => ({ id, ...item }))
      ).map((t) => ({ ...t, estado_del_ticket: normalizarEstado(t.estado_del_ticket) }));
      setDatos(lista);
    } catch (error) {
      console.error("Error al obtener tickets:", error);
      avisar("No se pudieron cargar los tickets", "error");
    } finally {
      setCargando(false);
    }
  }, [avisar]);

  const capturarAuxiliares = useCallback(async () => {
    const [cats, usrs] = await Promise.all([cargarCategorias(), cargarUsuariosTickets()]);
    setCategorias(cats);
    setUsuarios(usrs);
  }, []);

  useEffect(() => {
    capturarDatos();
    capturarAuxiliares();
  }, [capturarDatos, capturarAuxiliares]);


  const datosPropios = useMemo(
    () => (esSoporte ? datos : datos.filter((t) => t.correo_solicitante === correoActual)),
    [datos, esSoporte, correoActual]
  );

  const datosVisibles = useMemo(() => {
    return datosPropios.filter((t) => {
      if (filtros.estado !== TODOS && t.estado_del_ticket !== filtros.estado) return false;
      if (filtros.responsable !== TODOS && (t.responsable_del_ticket || "") !== filtros.responsable) return false;
      if (filtros.categoria !== TODOS && (t.categoria || "") !== filtros.categoria) return false;

      const fecha = soloFecha(t.fecha_del_reporte);
      if (filtros.desde && fecha < filtros.desde) return false;
      if (filtros.hasta && fecha > filtros.hasta) return false;

      return true;
    });
  }, [datosPropios, filtros]);

  const resumen = useMemo(() => {
    const conteo = ESTADOS.reduce((acc, e) => ({ ...acc, [e]: 0 }), {});
    datosPropios.forEach((t) => {
      conteo[t.estado_del_ticket] = (conteo[t.estado_del_ticket] || 0) + 1;
    });
    return conteo;
  }, [datosPropios]);

  const cambiarFiltro = (campo) => (e) => setFiltros((f) => ({ ...f, [campo]: e.target.value }));

  const limpiarFiltros = () =>
    setFiltros({ estado: TODOS, responsable: TODOS, categoria: TODOS, desde: "", hasta: "" });

  const hayFiltros =
    filtros.estado !== TODOS || filtros.responsable !== TODOS ||
    filtros.categoria !== TODOS || filtros.desde || filtros.hasta;


  const subirFotos = useCallback(async (archivos, subcarpeta = "") => {
    const nit = localStorage.getItem("CodigoCliente");
    return Promise.all(
      archivos.map((archivo) =>
        subirArchivoFirebase(`uploads/${nit}/tickets/${subcarpeta}${Date.now()}_${archivo.name}`, archivo)
      )
    );
  }, []);

  const subirFirma = useCallback(async (dataUrl, tipo) => {
    if (!dataUrl || !dataUrl.startsWith("data:")) return dataUrl || "";
    const nit = localStorage.getItem("CodigoCliente");
    const blob = await fetch(dataUrl).then((r) => r.blob());
    const archivo = new File([blob], `firma_${tipo}_${Date.now()}.png`, { type: "image/png" });
    return subirArchivoFirebase(`uploads/${nit}/tickets/firmas/${archivo.name}`, archivo);
  }, []);


  const guardarNuevo = useCallback(async (formulario, archivos) => {
    try {
      const urls = await subirFotos(archivos);
      const { fecha, hora, completo } = ahora();

      const contadorActual = Number(await consultarSimple("tickets/contador")) || datos.length;
      const nuevoContador = contadorActual + 1;

      const nuevoTicket = {
        categoria: formulario.categoria,
        estado_del_ticket: "Pendiente",
        cargo_funcionario: formulario.cargo,
        nombre_funcionario: formulario.nombre,
        proceso_del_funcionario: formulario.proceso,
        correo_solicitante: formulario.correo || correoActual,
        descripcion_problema: formulario.descripcion,
        descripcion_solucion: "",
        responsable_del_ticket: "",
        ...repartirFotos(urls, CAMPOS_FOTO),
        ...repartirFotos([], CAMPOS_SOLUCION),
        url_firma_tecnologia: "",
        url_firma_solicitante: "",
        id_fotos: completo,
        fecha_del_reporte: fecha,
        hora_del_reporte: hora,
        fecha_fin_solucion: "",
        hora_fin_solucion: "",
        fecha_creacion: completo,
        usuario_creacion: correoActual,
        contador: nuevoContador,
      };
      await crearRegistro(`/${RUTA_LISTADO}`, nuevoTicket);
      await actualizarRegistro("tickets/contador", nuevoContador);
      enviarCorreoTicket(nuevoTicket);

      cerrarModal();
      avisar("Ticket creado correctamente");
      capturarDatos();
    } catch (error) {
      console.error("Error al crear ticket:", error);
      avisar("No se pudo crear el ticket", "error");
    }
  }, [subirFotos, datos.length, correoActual, cerrarModal, avisar, capturarDatos]);


  const guardarGestion = useCallback(async (ticket, formulario, { urlsSolucion, archivosSolucion }) => {
    try {
      const nombreUsuario = localStorage.getItem("NombreCompleto") || "Usuario";
      const { fecha, hora, completo } = ahora();

      const solucionFinal =
        formulario.solucion && formulario.solucion !== ticket.descripcion_solucion
          ? `${formulario.solucion}\n\nUsuario: ${nombreUsuario}\nFecha: ${fecha}\n\n`
          : formulario.solucion;

      const nuevasUrls = await subirFotos(archivosSolucion, "soluciones/");

      const [firmaSolicitante, firmaTecnologia] = await Promise.all([
        subirFirma(formulario.firmaSolicitante, "solicitante"),
        subirFirma(formulario.firmaTecnologia, "tecnologia"),
      ]);

      const estabaFinalizado = ticket.estado_del_ticket === "Finalizado";
      const seFinaliza = formulario.estado === "Finalizado";
      const empieza = formulario.estado === "En Proceso" && !ticket.fecha_inicio_solucion;

      const actualizado = {
        ...ticket,
        estado_del_ticket: formulario.estado,
        responsable_del_ticket: formulario.responsable || "",
        nombre_funcionario: formulario.nombre || "",
        cargo_funcionario: formulario.cargo || "",
        proceso_del_funcionario: formulario.proceso || "",
        correo_solicitante: formulario.correo || "",
        fecha_del_reporte: formulario.fecha || ticket.fecha_del_reporte,
        descripcion_solucion: solucionFinal,
        ...repartirFotos([...urlsSolucion, ...nuevasUrls], CAMPOS_SOLUCION),
        url_firma_solicitante: firmaSolicitante,
        url_firma_tecnologia: firmaTecnologia,
        fecha_actualizacion: completo,
        usuario_actualizacion: correoActual,
      };

      if (empieza) {
        actualizado.fecha_inicio_solucion = fecha;
        actualizado.hora_inicio_solucion = hora;
      }

      if (seFinaliza && !estabaFinalizado) {
        actualizado.fecha_fin_solucion = fecha;
        actualizado.hora_fin_solucion = hora;
      } else if (!seFinaliza && estabaFinalizado) {
        actualizado.fecha_fin_solucion = "";
        actualizado.hora_fin_solucion = "";
      }

      const ruta = ticket._rutaOrigen || RUTA_LISTADO;
      delete actualizado._rutaOrigen;
      delete actualizado.id;

      await actualizarRegistro(`/${ruta}/${ticket.id}`, actualizado);

      cerrarModal();
      avisar("Ticket actualizado correctamente");
      capturarDatos();
    } catch (error) {
      console.error("Error al actualizar ticket:", error);
      avisar("No se pudo actualizar el ticket", "error");
    }
  }, [subirFotos, subirFirma, correoActual, cerrarModal, avisar, capturarDatos]);


  const duplicarTicket = useCallback((ticket) => {
    setModal({ tipo: "duplicar", ticket });
  }, []);

  const confirmarDuplicado = useCallback(async (ticket, { fecha, descripcion }) => {
    try {
      const { hora, completo } = ahora();
      const contadorActual = Number(await consultarSimple("tickets/contador")) || datos.length;
      const nuevoContador = contadorActual + 1;

      const duplicado = {
        categoria: ticket.categoria || "",
        estado_del_ticket: "Pendiente",
        cargo_funcionario: ticket.cargo_funcionario || "",
        nombre_funcionario: ticket.nombre_funcionario || "",
        proceso_del_funcionario: ticket.proceso_del_funcionario || "",
        correo_solicitante: ticket.correo_solicitante || "",
        descripcion_problema: descripcion || "",
        descripcion_solucion: "",
        responsable_del_ticket: "",
        ...repartirFotos(fotosDe(ticket, CAMPOS_FOTO), CAMPOS_FOTO),
        ...repartirFotos([], CAMPOS_SOLUCION),
        url_firma_tecnologia: "",
        url_firma_solicitante: "",
        id_fotos: completo,
        fecha_del_reporte: fecha || soloFecha(completo),
        hora_del_reporte: hora,
        fecha_fin_solucion: "",
        hora_fin_solucion: "",
        fecha_creacion: completo,
        usuario_creacion: correoActual,
        contador: nuevoContador,
      };
      await crearRegistro(`/${RUTA_LISTADO}`, duplicado);
      await actualizarRegistro("tickets/contador", nuevoContador);
      enviarCorreoTicket(duplicado);

      cerrarModal();
      avisar("Ticket duplicado correctamente");
      capturarDatos();
    } catch (error) {
      console.error("Error al duplicar ticket:", error);
      avisar("No se pudo duplicar el ticket", "error");
    }
  }, [datos.length, correoActual, cerrarModal, avisar, capturarDatos]);


  const eliminarTicket = useCallback((ticket) => {
    pedirConfirmacion({
      titulo: "¿Eliminar este ticket?",
      mensaje: (
        <>
          <div className="tk-bloque" style={{ borderLeft: "3px solid #e74c3c", marginBottom: 12 }}>
            <strong>#{ticket.contador} · {ticket.categoria}</strong>
            <p style={{ margin: "6px 0 0", color: "var(--tk-gris)", fontSize: "0.82rem" }}>
              {ticket.nombre_funcionario} — {ticket.estado_del_ticket}
            </p>
          </div>
          Esta acción no se puede deshacer.
        </>
      ),
      alConfirmar: async () => {
        try {
          const ruta = ticket._rutaOrigen || RUTA_LISTADO;
          await eliminarRegistro(`/${ruta}/${ticket.id}`);
          avisar("Ticket eliminado");
          capturarDatos();
        } catch (error) {
          console.error("Error al eliminar ticket:", error);
          avisar("No se pudo eliminar el ticket", "error");
        }
      },
    });
  }, [pedirConfirmacion, avisar, capturarDatos]);


  const arreglarContador = useCallback(() => {
    pedirConfirmacion({
      titulo: "¿Arreglar el contador?",
      peligro: false,
      textoConfirmar: "Sí, arreglar",
      mensaje: `Se renumeran los ${datos.length} tickets (todos los años) ordenándolos por fecha de reporte. No se borra ni se mueve ningún ticket.`,
      alConfirmar: async () => {
        try {
          const ordenados = [...datos].sort(
            (a, b) => new Date(a.fecha_del_reporte || 0) - new Date(b.fecha_del_reporte || 0)
          );

          const actualizaciones = {};
          ordenados.forEach((ticket, i) => {
            const ruta = ticket._rutaOrigen || RUTA_LISTADO;
            actualizaciones[`${ruta}/${ticket.id}/contador`] = i + 1;
          });
          actualizaciones["tickets/contador"] = ordenados.length;

          await actualizarMultiple(actualizaciones);
          avisar(`Contador arreglado: ${ordenados.length} tickets renumerados`);
          capturarDatos();
        } catch (error) {
          console.error("Error al arreglar el contador:", error);
          avisar("No se pudo arreglar el contador", "error");
        }
      },
    });
  }, [datos, pedirConfirmacion, avisar, capturarDatos]);

  const rellenarSolicitantes = useCallback(async () => {
    if (usuarios.length === 0) {
      avisar("Primero registra usuarios de tickets para poder cruzar los datos", "info");
      return;
    }

    const porNombre = {};
    usuarios.forEach((u) => {
      if (u.Nombre_Completo) porNombre[normalizarNombre(u.Nombre_Completo)] = u;
    });

    const pendientes = datos.filter((t) => !t.correo_solicitante && t.nombre_funcionario);
    const actualizaciones = {};
    let encontrados = 0;

    pendientes.forEach((ticket) => {
      const usuario = porNombre[normalizarNombre(ticket.nombre_funcionario)];
      if (!usuario) return;
      const ruta = ticket._rutaOrigen || RUTA_LISTADO;
      actualizaciones[`${ruta}/${ticket.id}/correo_solicitante`] = usuario.Usuario || "";
      if (!ticket.cargo_funcionario && usuario.Cargo) {
        actualizaciones[`${ruta}/${ticket.id}/cargo_funcionario`] = usuario.Cargo;
      }
      encontrados++;
    });

    if (encontrados === 0) {
      avisar(`Se revisaron ${pendientes.length} tickets, pero ninguno coincidió por nombre`, "info");
      return;
    }

    pedirConfirmacion({
      titulo: "¿Rellenar solicitantes faltantes?",
      peligro: false,
      textoConfirmar: "Sí, rellenar",
      mensaje: `Hay ${pendientes.length} tickets sin correo de solicitante y ${encontrados} se pueden completar cruzando por nombre con los usuarios de tickets.`,
      alConfirmar: async () => {
        try {
          await actualizarMultiple(actualizaciones);
          avisar(`${encontrados} tickets actualizados con su solicitante`);
          capturarDatos();
        } catch (error) {
          console.error("Error al rellenar solicitantes:", error);
          avisar("No se pudo completar la actualización", "error");
        }
      },
    });
  }, [usuarios, datos, pedirConfirmacion, avisar, capturarDatos]);


  if (cargando) return <AnimacionCarga />;

  const botones = [
    { texto: "Ver", icono: "bi-eye", accion: (t) => setModal({ tipo: "detalle", ticket: t }) },
  ];
  if (esSoporte) {
    botones.push({ texto: "Gestionar", icono: "bi-pencil", accion: (t) => setModal({ tipo: "gestionar", ticket: t }) });
    botones.push({ texto: "Duplicar", icono: "bi-copy", accion: duplicarTicket });
    botones.push({ texto: "Eliminar", icono: "bi-trash", accion: eliminarTicket });
  }

  const renderizadores = {
    estado_del_ticket: (valor) => <BadgeEstado estado={valor} />,
    fecha_del_reporte: (valor) => fechaLegible(valor),
    contador: (valor) => <strong style={{ color: "var(--tk-gris)" }}>#{valor || "—"}</strong>,
    descripcion_problema: (valor) => (
      <span title={valor} style={{ display: "inline-block", maxWidth: 320, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", verticalAlign: "middle" }}>
        {valor || "—"}
      </span>
    ),
  };

  return (
    <div className="tk">
      <BarraSuperior />

      <div className="tk-cabecera-modulo">
        <div className="tk-encabezado">
          <div>
            <h1>Tickets</h1>
            <p>
              {datosVisibles.length} de {datosPropios.length} tickets
              {esSoporte ? "" : " reportados por ti"}
            </p>
          </div>

          <div className="tk-acciones">
            <button type="button" className="tk-btn tk-btn-icono" title="Refrescar" onClick={capturarDatos}>
              <i className="bi bi-arrow-clockwise" />
            </button>

            {esSoporte && (
              <>
                <button type="button" className="tk-btn" onClick={() => navegar("/tickets_categorias")}>
                  <i className="bi bi-tags" /> Categorías
                </button>
                <button type="button" className="tk-btn" onClick={() => navegar("/tickets_usuarios")}>
                  <i className="bi bi-people" /> Usuarios
                </button>
                <button type="button" className="tk-btn tk-btn-icono" title="Rellenar solicitantes faltantes" onClick={rellenarSolicitantes}>
                  <i className="bi bi-person-fill-add" />
                </button>
                <button type="button" className="tk-btn tk-btn-icono" title="Arreglar contador" onClick={arreglarContador}>
                  <i className="bi bi-wrench-adjustable" />
                </button>
              </>
            )}

            <CSVLink
              data={datosVisibles}
              headers={COLUMNAS_CSV}
              filename="listado_tickets.csv"
              separator=";"
              className="tk-btn"
              title="Exportar a CSV"
            >
              <i className="bi bi-download" /> Exportar
            </CSVLink>

            <button type="button" className="tk-btn tk-btn-primario" onClick={() => setModal({ tipo: "crear" })}>
              <i className="bi bi-plus-lg" /> Nuevo ticket
            </button>
          </div>
        </div>

        <div className="tk-kpis">
          <button
            type="button"
            className={`tk-kpi ${filtros.estado === TODOS ? "activa" : ""}`}
            onClick={() => setFiltros((f) => ({ ...f, estado: TODOS }))}
          >
            <span className="tk-kpi-etiqueta">
              <span className="tk-kpi-punto" style={{ background: "var(--tk-tinta)" }} />
              Todos
            </span>
            <span className="tk-kpi-valor">{datosPropios.length}</span>
            <span className="tk-kpi-pie">Sin filtrar por estado</span>
          </button>

          {ESTADOS.map((estado) => (
            <button
              key={estado}
              type="button"
              className={`tk-kpi ${filtros.estado === estado ? "activa" : ""}`}
              onClick={() => setFiltros((f) => ({ ...f, estado: f.estado === estado ? TODOS : estado }))}
            >
              <span className="tk-kpi-etiqueta">
                <span className="tk-kpi-punto" style={{ background: paletaEstado(estado).punto }} />
                {estado}
              </span>
              <span className="tk-kpi-valor">{resumen[estado] || 0}</span>
              <span className="tk-kpi-pie">
                {datosPropios.length ? Math.round(((resumen[estado] || 0) / datosPropios.length) * 100) : 0}% del total
              </span>
            </button>
          ))}
        </div>

        <div className="tk-filtros">
          <div className="tk-filtro">
            <label>Estado</label>
            <select value={filtros.estado} onChange={cambiarFiltro("estado")}>
              <option value={TODOS}>Todos</option>
              {ESTADOS.map((e) => <option key={e} value={e}>{e}</option>)}
            </select>
          </div>

          <div className="tk-filtro">
            <label>Responsable</label>
            <select value={filtros.responsable} onChange={cambiarFiltro("responsable")}>
              <option value={TODOS}>Todos</option>
              <option value="">Sin asignar</option>
              {RESPONSABLES.map((r) => <option key={r} value={r}>{r}</option>)}
            </select>
          </div>

          <div className="tk-filtro">
            <label>Categoría</label>
            <select value={filtros.categoria} onChange={cambiarFiltro("categoria")}>
              <option value={TODOS}>Todas</option>
              {categorias.map((c) => (
                <option key={c.id} value={c.descripcion_categoria}>{c.descripcion_categoria}</option>
              ))}
            </select>
          </div>

          <div className="tk-filtro">
            <label>Desde</label>
            <input type="date" value={filtros.desde} onChange={cambiarFiltro("desde")} />
          </div>

          <div className="tk-filtro">
            <label>Hasta</label>
            <input type="date" value={filtros.hasta} onChange={cambiarFiltro("hasta")} />
          </div>

          <div className="tk-filtro">
            <label style={{ visibility: "hidden" }}>Limpiar</label>
            <button type="button" className="tk-btn" onClick={limpiarFiltros} disabled={!hayFiltros} style={{ width: "100%" }}>
              <i className="bi bi-x-circle" /> Limpiar
            </button>
          </div>
        </div>
      </div>

      <TablaGenerica
        datos={datosVisibles}
        titulos={COLUMNAS.map((c) => c.label.toUpperCase())}
        campos={COLUMNAS.map((c) => c.key)}
        elementosPorPagina={500}
        columnaOrdenInicial={0}
        direccionOrdenInicial="desc"
        botones={botones}
        renderizadores={renderizadores}
        mostrarBarraSuperior={false}
      />

      {modal?.tipo === "crear" && (
        <ModalCrear
          categorias={categorias}
          usuarios={usuarios}
          correoActual={correoActual}
          alGuardar={guardarNuevo}
          alCerrar={cerrarModal}
        />
      )}

      {modal?.tipo === "gestionar" && (
        <ModalGestionar
          ticket={modal.ticket}
          usuarios={usuarios}
          alAmpliar={setFotoAmpliada}
          alCerrar={cerrarModal}
          alGuardar={(formulario, fotos) => guardarGestion(modal.ticket, formulario, fotos)}
        />
      )}

      {modal?.tipo === "duplicar" && (
        <ModalDuplicar
          ticket={modal.ticket}
          alCerrar={cerrarModal}
          alGuardar={(valores) => confirmarDuplicado(modal.ticket, valores)}
        />
      )}

      {modal?.tipo === "detalle" && (
        <ModalDetalle ticket={modal.ticket} alCerrar={cerrarModal} alAmpliar={setFotoAmpliada} />
      )}

      {fotoAmpliada && <VisorFoto url={fotoAmpliada} alCerrar={() => setFotoAmpliada(null)} />}

      {confirmacion}
      {aviso}

      <BotonSOS />
    </div>
  );
});

export default ListadoTickets;
